import React from "react";
import { Box, Button, Flex, Grid, Heading, Stack, Text } from "@chakra-ui/react";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { ClientProfileTypeSelector } from "./components/ClientProfileTypeSelector";
import { HomeownerRequestForm } from "./components/HomeownerRequestForm";
import { OrganizationRequestForm } from "./components/OrganizationRequestForm";
import { REQUEST_CATEGORIES } from "./graphql";
import { Category, ClientProfileType } from "./types";

export const HomeownerRequestCreatePage = () => {
  const history = useHistory();
  const [clientProfileType, setClientProfileType] =
    React.useState<ClientProfileType>("HOMEOWNER");

  const { data: categoriesData } = useQuery<{ categories: Category[] }>(REQUEST_CATEGORIES, {
    variables: { excludeSystemKeys: ["ORDER_FALLBACK"] },
  });

  const categories = categoriesData?.categories.filter((category) => category.isVisible) || [];

  return (
    <Box px={{ base: 4, lg: 8 }} py={6} bg="gray.50" minH="calc(100vh - 80px)">
      <Flex justify="space-between" align={{ base: "flex-start", md: "center" }} gap={4} mb={6}>
        <Box>
          <Heading size="lg" color="gray.800">
            Create request
          </Heading>
          <Text color="gray.600" mt={1}>
            Create a one-time service request from a client profile.
          </Text>
        </Box>
        <Button variant="outline" onClick={() => history.push("/orders/all")}>
          Back to orders
        </Button>
      </Flex>

      <Grid templateColumns={{ base: "1fr", xl: "320px 1fr" }} gap={6}>
        <Stack spacing={4}>
          <ClientProfileTypeSelector
            value={clientProfileType}
            onChange={setClientProfileType}
          />
        </Stack>

        {clientProfileType === "HOMEOWNER" ? (
          <HomeownerRequestForm categories={categories} />
        ) : (
          <OrganizationRequestForm categories={categories} />
        )}
      </Grid>
    </Box>
  );
};
